export default __webpack_public_path__ + "static/media/review.23c29b6c.png";